import React, { useState } from "react";
import { MenuIcon } from "../Icons/Interface";
import SimpleButton from "../Input/SimpleButton";
import {
	Menu,
	MenuBadge,
	MenuContainer,
	MenuItemElement,
	MenuAlignment,
	MenuDirection
} from "./Menu"; // Import the updated component
import { ActionItem, keyFunc } from "./Actionitem";
import { toTitleCase } from "../../../Utilities/ToTitleCase";
import { JobCardData } from "../../../DataModels/DataModels";

interface JobCardMenuProps<T> {
	jobKey: T;
	onStatusChange?: (isOpen: boolean) => void;
	badgeClass?: string;
	menuClass?: string;
	itemClass?: string;
	alignment?: MenuAlignment;
	direction?: MenuDirection;
	actionList: ActionItem<T>[];
}

export const JobCardMenu: React.FC<JobCardMenuProps<JobCardData>> = ({
	jobKey,
	onStatusChange = (isOpen: boolean) => {},
	badgeClass = "border-0 px-1",
	menuClass = "bg-primary-background space-y-2 rounded-2xl border border-primary-active w-36 overflow-clip",
	itemClass = "text-primary-active hover:bg-primary-accent px-3 py-2 first:rounded-t-2xl last:rounded-b-2xl",
	alignment = "right",
	direction = "below",
	actionList
}) => {
	const [, /*isOpenA*/ setIsOpenA] = useState(false);

	return (
		<Menu
			onClickMenu={(func: keyFunc<JobCardData>) => func(jobKey)}
			onStatus={(isOpen: boolean) => {
				onStatusChange(isOpen);
				setIsOpenA(isOpen);
			}}
		>
			<MenuBadge
				className={`flex items-center`}
				align={alignment}
				direction={direction}
			>
				<SimpleButton className={badgeClass}>
					<div>{MenuIcon()}</div>
				</SimpleButton>
			</MenuBadge>
			<MenuContainer className={menuClass}>
				{actionList.map((item: ActionItem<JobCardData>, index) => (
					<MenuItemElement
						key={index}
						itemKey={item.actionFunc}
						className={itemClass}
					>
						<p>{toTitleCase(item.actionText)}</p>
					</MenuItemElement>
				))}
			</MenuContainer>
		</Menu>
	);
};
